<template>
  <div  class="Tyshxydm">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="width: calc(100% - 225px)"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="单位名称:">
                <el-input v-model="formInline.dwmc"  placeholder="请输入完整单位名称" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="信用代码:">
                <el-input v-model="formInline.xydmVal"  placeholder="请输入完整信用代码" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执行状态:">
                <el-select filterable v-model="formInline.status" placeholder="请选择" clearable>
                  <el-option
                    v-for="item in ztList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width:225px">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            size="small"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            icon="el-icon-refresh-left"
            round
            size="small"
            @click="resetDataSource"
          >重置</el-button>
        </div>

      </div>
    </div>
    <div style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;">
      <div class="tablemes">
        <div
          style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
        >
          <el-button
            v-preventReClick
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="addLoad()"
          >新增</el-button>
        </div>
        <el-table
          ref="gmzHqfxTabel"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="dwmc"
            label="单位名称"
          />
          <el-table-column
            prop="oldVal"
            label="旧信用代码"
          />
          <el-table-column
            prop="newVal"
            label="新信用代码"
          />
          <el-table-column
            label="执行状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == '2'" style="color: red">{{ scope.row.statusLabel }}</span>
              <span v-else-if="scope.row.status == '1'" style="color: green">{{ scope.row.statusLabel }}</span>
              <span v-else>{{ scope.row.statusLabel }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zxsj"
            label="执行时间"
          />
          <el-table-column
            prop="sbyy"
            label="失败原因"
          />
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="updFlag">
      <el-form :model="saveFrom" label-width="150px">
        <el-form-item label="旧信用代码:">
          <el-input
            v-model="saveFrom.oldVal"
          />
        </el-form-item>
        <el-form-item label="新信用代码:">
          <el-input
            v-model="saveFrom.newVal"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updFlag = false">取 消</el-button>
        <el-button type="primary" @click="dataSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {updxydmList,addSave} from "@/assets/js/tyshxydm";

  export default {
    name:'Tyshxydm',
    data(){
      return {
        dataId:'', //编辑时的数据主键
        title:'',
        updFlag: false,
        formInline: { // 搜索表单
          dwmc: '',
          xydmVal: '',
          status: ''
        },
        saveFrom: {
          id: '',
          oldVal: '',
          newVal: '',
        },
        currentPage: 1, // 当前页
        pagesize: 10, // 每页的数据条数
        total: 0, // 列表总数
        tableData: [], // 表格数据
        ztList:[
          {
            label: '待执行',
            value: '0'
          },
          {
            label: '成功',
            value: '1'
          },
          {
            label: '失败',
            value: '2'
          }
        ],
      }
    },
    mounted() {
      this.loadDatasource()
    },
    methods:{
      // 当前页码改变时
      handleCurrentChange(val) {
        this.currentPage = val // 当前页
        this.loadDatasource()
      },
      // 查询列表数据
      loadDatasource() {
        updxydmList({
          page: this.currentPage,
          size: this.pagesize,
          param: this.formInline
        }).then((e) => {
          this.tableData = e.data.data.rows
          this.total = e.data.data.total
        })
      },
      // 当前页码改变时
      handleCurrentChange(val) {
        this.currentPage = val // 当前页
        this.loadDatasource()
      },
      // 10条/页改变时
      handleSizeChange(val) {
        this.pagesize = val
        this.loadDatasource()
      },
      // 重置
      resetDataSource() {
        this.formInline = { // 搜索表单
          dwmc: '',
          xydmVal: '',
          status: ''
        },
          this.loadDatasource()
      },
      addLoad(){
        this.dataId = '';
        this.title = '新增变更记录';
        this.saveFrom = {
          id: '',
          oldVal: '',
          newVal: ''
        }
        this.updFlag = true;
      },
      //新增
      dataSave(){
        this.$confirm('提交后立即生效，是否确定变更?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          addSave(this.saveFrom).then(()=>{
            this.$message.success('变更成功!')
            this.updFlag = false;
            this.loadDatasource()
          })
        })
        //
      },
    }
  }
</script>

<style scoped lang='less'>
  .Tyshxydm {
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
